import { isValid, addYears, compareDesc } from 'date-fns'

const validationKeys = ['hasTwoYearsResidenceHistory'] as const

type ValidationKeys = typeof validationKeys[number]
type QuestionGroupValidationFn = (values: Record<string, any>) => boolean

type ValidateCondition = {
  [key in ValidationKeys]: QuestionGroupValidationFn
}

export const customFormValidations: ValidateCondition = {
  hasTwoYearsResidenceHistory: (values): boolean => {
    const moveInDate = new Date(values.moveInDate) || null
    const moveOutDate = new Date(values.moveOutDate) || null

    if (isValid(moveInDate) && isValid(moveOutDate)) {
      const twoYearsAfterMoveIn = addYears(moveInDate, 2)
      const isTwoYears = compareDesc(twoYearsAfterMoveIn, moveOutDate) > 0

      return isTwoYears
    }

    return false
  },
}
